import { Plugin } from "@nuxt/types"
import Analytics from "~/utils/analytics"

const analytics: Plugin = (ctx, inject) => {
  const analyticsInstance = new Analytics(ctx)

  inject('analytics', analyticsInstance)
}

export default analytics
